import React, { useEffect, useRef } from 'react';
import { Animated, Easing, StyleProp, ViewStyle } from 'react-native';

/**
 * Wraps real content with a 100ms opacity fade-in on mount (TA-10089 global
 * rule: "after data arrives, replace skeleton rows with a short fade-in").
 * Deliberately just the fade — pairs with `useMinimumVisible` for the
 * min-display-time half of the swap; does not do any data/loading logic
 * itself.
 */
const FADE_IN_DURATION_MS = 100;

interface FadeInViewProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

export const FadeInView: React.FC<FadeInViewProps> = ({
  children,
  style,
  testID,
}) => {
  const opacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const animation = Animated.timing(opacity, {
      toValue: 1,
      duration: FADE_IN_DURATION_MS,
      easing: Easing.ease,
      useNativeDriver: true,
    });
    animation.start();

    return () => {
      animation.stop();
    };
  }, [opacity]);

  return (
    <Animated.View testID={testID} style={[{ opacity }, style]}>
      {children}
    </Animated.View>
  );
};
